<template>
  <span :class="colorCls">
    <span v-if="drawBrace"> ( </span> {{ x }} <span v-if="drawBrace"> ) </span>
  </span>
</template>

<script>
export default {
  name: 'Showpoly',
  props: {
    x: Number,
    brace: {type: Boolean, default: false},
    color: {type: Number, default: 0}
  },
  computed: {
    drawBrace(){
      return this.brace && (this.x < 0);
    },
    colorCls(){
      return ['black','red','orange','green','blue','violet'][this.color];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.black {
    color: #000;
}
.red {
    color: #f00;
}
.orange {
    color: #f80;
}
.yellow {
    color: #bb0;
}
.green {
    color: #080;
}
.blue {
    color: #00b;
}
.violet {
    color: #808;
}
</style>
